import React, { Fragment } from 'react';
import { Field } from 'redux-form';

import { TextInput, SelectInput, SwitchInput } from '../../_Components';
import { Options } from '../../_utils/_constants';

const TypeOptions = Options.FieldsTypesOptions;

const fieldOptions = (fields = [], usedIds = []) => {
    const used = new Set((usedIds || []).filter(Boolean).map(String));
    return (fields || [])
        .filter((item) => item && item.id)
        .slice()
        .sort((a, b) => {
            const aUsed = used.has(String(a.id));
            const bUsed = used.has(String(b.id));
            if (aUsed !== bUsed) return aUsed ? 1 : -1;
            return String(a.name || a.id).localeCompare(String(b.name || b.id), 'ru');
        })
        .map((item) => {
            const taken = used.has(String(item.id));
            return {
                id: item.id,
                name: taken ? `${item.name || item.id} — уже в форме` : (item.name || item.id),
                login: item.id,
                type: item.type,
                disabled: taken,
            };
        });
};

const AddColFields = ({ fields = [], items = [], formValues = {} }) => {
    const used = (items || []).map((item) => item.i || item.field);
    const options = fieldOptions(fields, used);
    const selected = formValues.field
        ? (fields || []).find((item) => item.id === formValues.field)
        : null;

    return (
        <Fragment>
            <div className="pc-fgrid">
                <div className="pc-f--full">
                    <Field
                        name="field"
                        required={true}
                        component={SelectInput}
                        options={options}
                        label="Поле проекта"
                        searchable
                        showValue
                        disablePortal
                        searchPlaceholder="Название или ключ"
                        placeholder="Найти поле"
                    />
                    <div className="pc-field__hint">
                        Список из вкладки «Поля» проекта. Можно искать по названию или ключу, например «Организация».
                    </div>
                </div>
                <Field
                    name="field"
                    component={TextInput}
                    label="Ключ"
                    disabled={true}
                    mono={true}
                />
                <SelectInput
                    label="Тип"
                    value={selected ? selected.type : ''}
                    disabled={true}
                    options={TypeOptions}
                />
            </div>
            <div className="pc-sect" style={{ paddingLeft: 0, paddingRight: 0 }}>
                <div className="pc-sect__t">В этой карточке</div>
                <div className="pc-togrow">
                    <div className="pc-togrow__txt">
                        <b>Обязательное</b>
                        <span>Без него карточку не закрыть</span>
                    </div>
                    <Field name="required" component={SwitchInput} />
                </div>
                <div className="pc-togrow">
                    <div className="pc-togrow__txt">
                        <b>Только чтение</b>
                        <span>Оператор видит, но не меняет</span>
                    </div>
                    <Field name="readonly" component={SwitchInput} />
                </div>
                <div className="pc-togrow">
                    <div className="pc-togrow__txt">
                        <b>Поле CRM</b>
                        <span>Подставить значение из найденной записи</span>
                    </div>
                    <Field name="crm" component={SwitchInput} />
                </div>
                {selected && selected.type === 'phone' && (
                    <div className="pc-togrow">
                        <div className="pc-togrow__txt">
                            <b>Телефон звонящего</b>
                            <span>Заполнить номером из вызова</span>
                        </div>
                        <Field name="callPhone" component={SwitchInput} />
                    </div>
                )}
                {selected && selected.type === 'name' && (
                    <div className="pc-togrow">
                        <div className="pc-togrow__txt">
                            <b>Полное имя</b>
                            <span>Собрать ФИО из отдельных полей</span>
                        </div>
                        <Field name="full_name" component={SwitchInput} />
                    </div>
                )}
            </div>
        </Fragment>
    );
};

export const addColInitial = {
    field: null,
    callPhone: false,
    crm: false,
    delete: false,
    full_name: false,
    last_name: false,
    readonly: false,
    required: false,
    second_name: false,
};

export default AddColFields;
